import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { RouteAction } from '@core/action/action';
import { CargoReferenciaService } from '@core/services/cargoreferencia.service';
import { NzModalRef } from 'ng-zorro-antd/modal';

@Component({
  selector: 'app-add-cargo',
  templateUrl: './add-cargo.component.html',
  styleUrl: './add-cargo.component.scss'
})
export class AddCargoComponent implements OnInit {
  adicionarCargoForm!: FormGroup;
  @Input() acao: any;
  @Input() item: any;

  inserir!: boolean;
  editar!: boolean;
  visualizar!: boolean;

  cargoReferenciaList: any;

  constructor(
    private fb: FormBuilder,
    private modalRef: NzModalRef,
    private cargoReferenciaService: CargoReferenciaService
  ) { }

  ngOnInit(): void {
    this.buildForm();
    this.cargoReferenciaService.listar().subscribe(cargos =>
      this.cargoReferenciaList = cargos);
    this.checkAcao();
  }

  buildForm(): void {
    this.adicionarCargoForm = this.fb.group({
      nomeCargo: [''],
      nivelHierarquico: [''],
      cargoReferencia: [''],
    })
  }

  handleOk(): void {
    let objEnvio = { ...this.adicionarCargoForm.getRawValue() };
    this.modalRef.close(objEnvio);
  }

  handleCancel(): void {
    this.modalRef.close();
  }

  checkAcao() {
    this.inserir = this.acao == RouteAction.Inserir;
    this.editar = this.acao == RouteAction.Editar;
    this.visualizar = this.acao == RouteAction.Visualizar;
  }

  compareFn(a: any, b: any): boolean {
    if (typeof a === 'boolean' && (typeof b === 'string' || typeof b === 'boolean')) {
      b = b === 'true';
    }

    if (a?.id !== undefined && b?.id !== undefined) {
      return a.id === b.id;
    }
    else if (a?.codigo !== undefined && b?.codigo !== undefined) {
      return a.codigo === b.codigo;
    }
    else {
      return a === b;
    }
  }
}
